// SelectEquipmentModal.js
import React, { useState, useEffect } from "react";
import { EQUIPMENT_CATEGORIES } from "../pages/carnets/categorieMapping";
import CategoryTreeView from "../pages/carnets/CategoryTreeView";
import getCategoryBrands from "../api/equipment/getCategorieBrands";
import getCategoryBrandModels from "../api/equipment/getCategorieBrandModels";
import getEquipmentByCategoryAndModel from "../api/equipment/getEquipmentByCategoryAndModel";
import Icon1 from "../icons/Icon";
import Modal1 from "./Modal1";
import {
  getFirstPage,
  getNextPage,
  queryCollection,
} from "../models/DataFunctions";
import addEquipmentsToCarnet from "../api/equipment/addEquipmentsToCarnet";
import { useSnackbar } from "notistack";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";
import TextField2T from "../textfields/TextField2T";
import EquipmentTypeSelect from "./EquipmentTypeSelect";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X";
import DatePickerGPT0 from "../textfields/DatePickerGPT0";
import MLTFGPT1 from "../textfields/MLTFGPT1";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3";
import { se } from "date-fns/locale";

type SelectEquipmentModalProps = {
  onClose: () => void;
  carnetId: string;
  onEquipmentSelected?: (equipment: any) => void;
  pieceOptions: string[];
  userData?: any;
  prefix?: string;
  onRefresh: () => void;
  handleAddNewPiece?: (some: string) => void;
};

const SelectEquipmentModal = ({
  onClose,
  carnetId,
  onEquipmentSelected,
  pieceOptions,
  userData,
  prefix,
  onRefresh,
  handleAddNewPiece = (some: string) => {},
}: SelectEquipmentModalProps) => {
  const [piece, setPiece] = useState(null);
  type EquipmentType = {
    label: string;
    eprel_filters: {
      product_group_code: string;
      type: string;
      [key: string]: any;
    };
    [key: string]: any;
  };

  const [selectedEquipmentType, setSelectedEquipmentType] =
    useState<EquipmentType | null>(null);
  const [brand, setBrand] = useState<string | null>(null);
  const [model, setModel] = useState("");
  const [equipmentRegistrationNumber, setEquipmentRegistrationNumber] =
    useState("");
  const [manualMode, setManualMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [directModels, setDirectModels] = useState<
    { id: string; ref: any; [key: string]: any }[]
  >([]);
  // États pour les données
  const [brands, setBrands] = useState<string[]>([]);
  const [models, setModels] = useState<string[]>([]);
  const [new_pieceName, setNew_pieceName] = useState("");
  const [openNewPiece, setOpenNewPiece] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  // États pour le chargement
  const [loading, setLoading] = useState({
    brands: false,
    models: false,
    equipment: false,
  });

  // Champs manuels inchangés
  const [manualBrand, setManualBrand] = useState("");
  const [manualModel, setManualModel] = useState("");
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [serialNumber, setSerialNumber] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [lifespan, setLifespan] = useState(10);
  const [characteristics, setCharacteristics] = useState("");
  const [expandedCategories, setExpandedCategories] = useState({});
  const [manualEquipmentType, setManualEquipmentType] = useState("");

  const [paginationEprel, setPaginationEprel] = useState<any>(null);

  // Auto-expand première catégorie au chargement
  useEffect(() => {
    // Auto-expand la première catégorie avec des équipments
    const firstCategoryKey = Object.keys(EQUIPMENT_CATEGORIES.categories)[0];
    if (firstCategoryKey) {
      setExpandedCategories({ [firstCategoryKey]: true });
    }
  }, []);

  useEffect(() => {
    if (selectedEquipmentType && !manualMode) {
      setBrand("");
      setModel("");
      setBrands([]);
      setModels([]);
    }
  }, [selectedEquipmentType, manualMode]);

  useEffect(() => {
    console.log(piece);
  }, [piece]);

  // Charger modèles quand une marque est sélectionnée
  useEffect(() => {
    if (selectedEquipmentType && brand && !manualMode) {
      setModel("");
      setModels([]);
      console.log("Loading models for brand:", brand);
    }
  }, [brand]);

  const handleEquipmentTypeSelect = async (equipmentType: any) => {
    setSelectedEquipmentType(equipmentType);
    setLoading((prev) => ({ ...prev, brands: true }));
    console.log(equipmentType);
    let equipmentFilters = [
      {
        field: "product_group_code",
        operator: "==",
        value: equipmentType.eprel_filters.product_group_code,
      },
      {
        field: "type",
        operator: "==",
        value: equipmentType.eprel_filters.type,
      },
    ];

    let eprelBrandsIndex = await queryCollection(
      "eprel_brands_index",
      equipmentFilters,
      1
    );
    console.log(eprelBrandsIndex);
    const brandsData =
      eprelBrandsIndex &&
      Array.isArray(eprelBrandsIndex) &&
      eprelBrandsIndex[0] &&
      "brands" in eprelBrandsIndex[0] &&
      Array.isArray((eprelBrandsIndex[0] as any).brands)
        ? (eprelBrandsIndex[0] as any).brands
        : [];
    setBrand("");
    setModel("");
    console.log("brandsData", brandsData);
    setBrands(brandsData);
    setModels([]);
    setLoading((prev) => ({ ...prev, brands: false }));
  };

  const handleBrandSelect = async (selectedBrand: any) => {
    console.log("Selected brand:", selectedBrand);
    setBrand(selectedBrand);
    setLoading((prev) => ({ ...prev, models: true }));
    console.log("selected brand", selectedBrand);
    let equipmentModalFilters = [];
    if (selectedEquipmentType) {
      equipmentModalFilters = [
        {
          field: "brand",
          operator: "==",
          value: selectedBrand,
        },
        {
          field: "product_group_code",
          operator: "==",
          value: selectedEquipmentType?.eprel_filters?.product_group_code,
        },
        {
          field: "type",
          operator: "==",
          value: selectedEquipmentType?.eprel_filters.type,
        },
      ];
    } else {
      equipmentModalFilters = [
        {
          field: "brand",
          operator: "==",
          value: selectedBrand,
        },
      ];
    }

    let eprelBrandModels = await queryCollection(
      "eprel_brand_models",
      equipmentModalFilters,
      1
    );
    console.log(eprelBrandModels);
    let modelsData =
      eprelBrandModels &&
      Array.isArray(eprelBrandModels) &&
      eprelBrandModels[0] &&
      typeof eprelBrandModels[0] === "object" &&
      "models" in eprelBrandModels[0] &&
      Array.isArray((eprelBrandModels[0] as any).models)
        ? (eprelBrandModels[0] as any).models
        : [];
    console.log("modelsData", modelsData);
    setModel("");
    setModels(modelsData);
    setLoading((prev) => ({ ...prev, models: false }));
  };

  const handleModelSelect = (selectedModel: any) => {
    setModel(selectedModel);
  };

  const handleDirectModelSelect = async (selectedModel: any) => {
    console.log("Selected direct model:", selectedModel);
    if (!selectedModel) {
      setBrand("");
      setModels([]);
      setModel("");
      return;
    }
    setModel(selectedModel);
    let brand = directModels.find(
      (model) => model.name === selectedModel
    )?.brand;
    console.log("Brand from direct model:", brand);
    setBrand(brand);
    setBrands([brand]);
    await handleBrandSelect(brand);
    setTimeout(() => {
      console.log("Setting model after delay:", selectedModel);
      console.log("Current model state:", models);
      console.log("Current model state:", models.includes(selectedModel));
      setModel(selectedModel);
    }, 200);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!piece) {
      alert("Veuillez sélectionner une pièce");
      return;
    }

    if (manualMode) {
      if (!manualBrand || !manualModel) {
        alert("Veuillez remplir la marque et le modèle");
        return;
      }

      const equipment = {
        piece,
        brand: manualBrand,
        model: manualModel,
        date_livraison: deliveryDate,
        num_serie: serialNumber,
        quantity: parseInt(quantity.toString()) || 1,
        lifespan: lifespan ? parseInt(lifespan.toString()) : null,
        notes: characteristics,
        equipment_type: manualEquipmentType,
        manual_entry: true,
      };
      try {
        setLoading((prev) => ({ ...prev, equipment: true }));
        await addEquipmentsToCarnet([equipment], carnetId, prefix);
        setLoading((prev) => ({ ...prev, equipment: false }));
        handleClickVariant("Équipement ajouté", "success");
        setLoading((prev) => ({ ...prev, equipment: false }));
        onRefresh();
      } catch (error) {
        setLoading((prev) => ({ ...prev, equipment: false }));
        console.error("Erreur lors de l'ajout de l'équipement:", error);
        handleClickVariant("Erreur lors de l'ajout de l'équipement", "error");
        return;
      }
      handleClose();
    } else {
      if (!brand || !model) {
        alert("Veuillez sélectionner une marque et un modèle");
        return;
      }

      setLoading((prev) => ({ ...prev, equipment: true }));
      try {
        const equipment = {
          piece,
          brand: brand,
          model: model,
          date_livraison: deliveryDate,
          num_serie: serialNumber,
          quantity: parseInt(quantity.toString()) || 1,
          lifespan: lifespan ? parseInt(lifespan.toString()) : null,
          notes: characteristics,
          equipment_type: selectedEquipmentType?.label,
          manual_entry: false,
        };

        await addEquipmentsToCarnet([equipment], carnetId, prefix);
        handleClickVariant("Équipement ajouté", "success");
        setLoading((prev) => ({ ...prev, equipment: false }));
        onRefresh();
        handleClose();
      } catch (error) {
        console.error("Erreur lors de la récupération de l'équipement:", error);
        alert("Erreur lors de la récupération de l'équipement");
      } finally {
        setLoading((prev) => ({ ...prev, equipment: false }));
      }
    }
  };

  const handleGetFromEPREL = async (value: string) => {
    setSearch(value);

    if (value.length < 2) {
      setDirectModels([]);
      setLoadingSearch(false);
      setPaginationEprel(null);
      return;
    }
    setLoadingSearch(true);
    const start = value;
    const end = value + "\uf8ff"; // Unicode character to match all characters after the search term

    let results: any = [];
    if (!paginationEprel) {
      results = await getFirstPage(
        "eprel_models",
        [
          {
            field: "name",
            operator: ">=",
            value: start,
          },
          {
            field: "name",
            operator: "<=",
            value: end,
          },
        ],
        20
      );
    } else {
    }
    if (!results?.data || results?.data.length === 0) {
      setPaginationEprel(null);
      setLoadingSearch(false);
      console.log("No more results found.");
      return;
    }
    console.log("Search results:", results);
    setDirectModels(results?.data ?? []);
    setPaginationEprel(results?.pagination ?? null);
    setLoadingSearch(false);
  };

  const handleGetNextFromEPREL = async (value: string) => {
    console.log("Fetching next page for:", value, paginationEprel);
    if (value.length < 2) {
      setDirectModels([]);
      setLoadingSearch(false);
      setPaginationEprel(null);
      return;
    }
    setLoadingSearch(true);
    const start = value;
    const end = value + "\uf8ff"; // Unicode character to match all characters after the search term

    let results: any = [];
    if (!paginationEprel) {
      console.error("Pagination is null, cannot fetch next page.");
    } else {
      results = await getNextPage(
        "eprel_models",
        [
          {
            field: "name",
            operator: ">=",
            value: start,
          },
          {
            field: "name",
            operator: "<=",
            value: end,
          },
        ],
        20,
        "__name__",
        "asc",
        paginationEprel?.lastCursor
      );
    }
    if (!results?.data || results?.data.length === 0) {
      setLoadingSearch(false);
      console.log("No more results found.");
      return;
    }

    console.log("Search results:", results);
    let allResults = directModels.concat(results?.data ?? []);
    // Remove duplicates based on the 'name' field
    const uniqueResults = Array.from(
      new Map(allResults.map((item) => [item.name, item])).values()
    );
    console.log("Unique results:", uniqueResults);
    setDirectModels(uniqueResults ?? []);
    setPaginationEprel(results?.pagination ?? null);
    setLoadingSearch(false);
  };

  const handleClose = () => {
    // Reset all states
    setPiece(null);
    setSelectedEquipmentType(null);
    setBrand("");
    setModel("");
    setManualBrand("");
    setManualModel("");
    setSearchQuery("");
    // ... reset autres états
    onClose();
  };

  return (
    <div className=" w-[1100px] h-[700px] min-h-[700px] max-h-[700px] p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-h1 font-medium leading-6 text-gray-900">
          Ajouter un nouvel équipement
        </h3>
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-gray-600 focus:outline-none"
        >
          <Icon1 icon_name="close"></Icon1>
        </button>
      </div>

      <div className="flex gap-8 flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {/* Left side - Category selection or manual input */}
        <div className="flex-1 space-y-4">
          <div className="mb-4">
            <div className="flex gap-4 mb-4">
              <PrimaryButton
                onClick={() => setManualMode(false)}
                className={`px-4 py-2 rounded-md ${
                  !manualMode ? " border-blue-600 border-2 " : ""
                }`}
              >
                Recherche avancée
              </PrimaryButton>
              <SecondaryButton
                onClick={() => setManualMode(true)}
                className={`px-4 py-2 rounded-md ${
                  manualMode ? " border-blue-600 border-2 " : ""
                }`}
              >
                Saisie manuelle
              </SecondaryButton>
            </div>
          </div>

          {!manualMode ? (
            <>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Rechercher un équipement par modèle
                </label>
                <div className="relative">
                  <DropDownGPTS3
                    value={search}
                    onChange={(e: any) => {
                      handleDirectModelSelect(e.value);
                    }}
                    //onOptionSelect={handleDirectModelSelect}
                    loadingSearch={loadingSearch}
                    items={directModels.map((model) => ({
                      label: model.name,
                      value: model.name,
                    }))}
                    debounceDelay={1000}
                    onFetchNewOptions={() => {
                      console.log(
                        "Fetching new options for direct model search",
                        search
                      );
                      handleGetNextFromEPREL(search);
                    }}
                    label={
                      loading.models
                        ? "Chargement..."
                        : "Sélectionnez un modèle"
                    }
                    onSearchChange={handleGetFromEPREL}
                    //onFetchNewOptions={setSearch}
                    hasMoreOptions={true}
                    //allowCustomInput={true}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Catégories d'équipements
                </label>
                <CategoryTreeView
                  categories={EQUIPMENT_CATEGORIES.categories}
                  selectedEquipmentType={selectedEquipmentType}
                  onEquipmentTypeSelect={handleEquipmentTypeSelect}
                  searchQuery={searchQuery}
                />
              </div>
            </>
          ) : (
            <>
              <div className="mb-4">
                <h4 className="text-lg font-medium text-gray-800 mb-3">
                  Saisie manuelle
                </h4>
                <p className="text-sm text-gray-600 mb-4">
                  Remplissez les informations de l'équipement manuellement
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <TextField2T
                    value={manualBrand}
                    onChange={(e) => setManualBrand(e.target.value)}
                    label="Fabricant"
                    mandatory={true}
                  />
                </div>
                <div>
                  <TextField2T
                    value={manualModel}
                    onChange={(e) => setManualModel(e.target.value)}
                    label="Modèle"
                    mandatory={true}
                  />
                </div>
              </div>

              <div>
                <EquipmentTypeSelect
                  label="Type d'équipement"
                  value={manualEquipmentType}
                  onChange={(value) => setManualEquipmentType(value)}
                />
              </div>
            </>
          )}
        </div>

        {/* Right side - Equipment details */}
        <div
          className={`flex-1 space-y-4 
            ${
              brands.length === 0 && !manualMode
                ? "opacity-50 pointer-events-none"
                : ""
            }
            `}
        >
          <div className=" flex flex-row gap-2">
            <DropDownGPTS3
              label="Pièce"
              value={piece || ""}
              onChange={(e) => {
                setPiece(e.value);
              }}
              items={pieceOptions as any}
              mandatory={true}
            />
            <SecondaryButton onClick={() => setOpenNewPiece(true)}>
              Ajouter une pièce
            </SecondaryButton>
          </div>
          {openNewPiece && (
            <>
              <div className="absolute w-c500 bg-white rounded-lg p-2 mt-4 flex flex-col gap-2 z-60">
                <TextField2T
                  value={new_pieceName}
                  onChange={(e) => setNew_pieceName(e.target.value)}
                  label="Nom de la nouvelle pièce"
                  mandatory={true}
                />
                <div className="flex flex-row gap-2 justify-end">
                  <PrimaryButton
                    onClick={() => {
                      handleAddNewPiece(new_pieceName);
                      setNew_pieceName("");
                      setOpenNewPiece(false);
                    }}
                  >
                    Ajouter la pièce
                  </PrimaryButton>
                  <SecondaryButton
                    onClick={() => {
                      setOpenNewPiece(false);
                      setNew_pieceName("");
                    }}
                  >
                    Annuler
                  </SecondaryButton>
                </div>
              </div>{" "}
              <div className="absolute bg-shadow_25 h-screen w-screen bottom-0 left-0 z-50 flex items-center justify-center"></div>
            </>
          )}
          {!manualMode && (
            <>
              <DropDownGPTS3
                label="Marque"
                value={brand || ""}
                onChange={(e: any) => handleBrandSelect(e.value)}
                items={brands.map((b) => ({
                  label: b,
                  value: b,
                }))}
                disabled={loading.brands}
              />

              <DropDownGPTS3
                value={model}
                onChange={(e: any) => handleModelSelect(e.value)}
                items={models.map((m) => ({
                  label: m,
                  value: m,
                }))}
                label={
                  loading.models ? "Chargement..." : "Sélectionnez un modèle"
                }
                disabled={!brand}
              />
            </>
          )}

          <div className="grid grid-cols-2 gap-4">
            <div>
              <DatePickerGPT0
                label="Date de livraison"
                seconds={deliveryDate}
                onChange={(value: any) => setDeliveryDate(value)}
              />
            </div>
            <div>
              <TextField2T
                value={serialNumber || ""}
                onChange={(e) => setSerialNumber(e.target.value)}
                label="Numéro de série"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <TextField2T
                type="number"
                value={
                  quantity !== undefined && quantity !== null
                    ? String(quantity)
                    : ""
                }
                onChange={(e) => setQuantity(e.target.value)}
                label="Quantité"
              />
            </div>
            <div>
              <TextField2T
                type="number"
                value={
                  lifespan !== undefined && lifespan !== null
                    ? String(lifespan)
                    : ""
                }
                onChange={(e) => setLifespan(e.target.value)}
                label="Durée de vie (années)"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Notes
            </label>
            <MLTFGPT1
              value={characteristics}
              onChange={(e) => setCharacteristics(e.target.value)}
              rows={4}
              label="Notes, remarques, caractéristiques, etc..."
            />
          </div>
        </div>
      </div>

      {/* Footer buttons */}
      <div className="flex justify-between items-center pt-6 border-t mt-6">
        <div className="text-xs text-gray-500">
          Inspiré de la base européenne EPREL
        </div>

        <div className="flex space-x-3">
          <button
            type="button"
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Annuler
          </button>
          <PrimaryButton
            type="submit"
            disabled={
              !piece ||
              (!manualMode && (!brand || !model)) ||
              (manualMode && (!manualBrand || !manualModel))
            }
            onClick={handleSubmit}
            className="px-6 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading.equipment ? (
              <span className="flex items-center">
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Ajout en cours...
              </span>
            ) : (
              "Ajouter l'équipement"
            )}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default SelectEquipmentModal;
